import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingScreenService } from '../services/loading-screen.service';

@Component({
  standalone: false,
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
  isPageLoading$: Observable<boolean>;

  constructor(
    public loadingScreenService: LoadingScreenService,
  ) { }

  ngOnInit(): void {
    this.isPageLoading$ = this.loadingScreenService.getLoadingStatus();
  }

}
